<!-- StepFive.vue -->
<template>
    <div class="space-y-4">
        <p class="text-gray-700">Please confirm all your details before submitting.</p>
        <div class="text-sm space-y-2 text-gray-800">
            <div><strong>Name:</strong> {{ form.personName }}</div>
            <div><strong>Email:</strong> {{ form.email }}</div>
            <div><strong>Phone:</strong> {{ form.phone }}</div>
            <div><strong>Business Address:</strong> {{ form.businessAddress }}</div>
            <div><strong>Bankers Name:</strong> {{ form.bankersName }}</div>
            <div><strong>Bankers Address:</strong> {{ form.bankersAddress }}</div>
        </div>
        <!-- <ul class="text-sm text-gray-600 space-y-1">
            <li><strong>Name:</strong> {{ form.fullName }}</li>
            <li><strong>Email:</strong> {{ form.email }}</li>
            <li><strong>Phone:</strong> {{ form.phone }}</li>
            <li><strong>DOB:</strong> {{ form.dob }}</li>
            <li><strong>Address:</strong> {{ form.address }}</li>c
            <li><strong>City:</strong> {{ form.city }}</li>
        </ul> -->
    </div>
</template>

<script>
    export default {
        props: ['form'],
    };
</script>
